import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrBulkUpdatePeopleEvidencePayload } from 'api/actions/hr-bulk-update-people-evidence/hr-bulk-update-people-evidence-payload';
import { HrBulkUpdatePeopleEvidencePathParameters } from 'api/actions/hr-bulk-update-people-evidence/hr-bulk-update-people-evidence-path-parameters';
import { HrBulkUpdatePeopleEvidenceResponse } from 'api/actions/hr-bulk-update-people-evidence/hr-bulk-update-people-evidence-response';

type HrBulkUpdatePeopleEvidenceQueryParameters = Record<string, any>;

/**
 * The path of the HrBulkUpdatePeopleEvidence action.
 */
export const hrBulkUpdatePeopleEvidenceActionPath = new SweetPath<keyof HrBulkUpdatePeopleEvidencePathParameters>(
  '/api/hr/people/bulk-evidence',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrBulkUpdatePeopleEvidence actions.
 */
export default function createHrBulkUpdatePeopleEvidenceAction(axios: AxiosInstance) {
  return function hrBulkUpdatePeopleEvidenceAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: HrBulkUpdatePeopleEvidenceQueryParameters;
    payload: HrBulkUpdatePeopleEvidencePayload;
  }) {
    const path = hrBulkUpdatePeopleEvidenceActionPath.original;

    return axios.request<HrBulkUpdatePeopleEvidenceResponse, HrBulkUpdatePeopleEvidenceResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
